// extracted by mini-css-extract-plugin
export default {"tableBodyCell":"TableReportChat_tableBodyCell__Hh-T9","tableContainer":"TableReportChat_tableContainer__RsEX7"};